import MigrationItemUpdated from './MigrationItemUpdated';

export default MigrationItemUpdated;
